import { type ReactNode, createContext, useContext, useEffect, useRef } from 'react';
import { McapVirtualMcapController, type McapVirtualMcapPageApi } from './browserController';

const McapVirtualMcapContext = createContext<McapVirtualMcapPageApi | null>(null);

/** Starts the root-scoped worker controller once and exposes page grant APIs. */
export function McapVirtualMcapProvider({ children }: { children: ReactNode }) {
  const controllerRef = useRef<McapVirtualMcapController | null>(null);
  controllerRef.current ??= new McapVirtualMcapController();
  const controller = controllerRef.current;

  useEffect(() => {
    void controller.start();
  }, [controller]);

  return (
    <McapVirtualMcapContext.Provider value={controller}>{children}</McapVirtualMcapContext.Provider>
  );
}

/**
 * This API owns only in-memory worker grants. Callers keep the stable virtual
 * URL in rosview and replace the grant only when its current lease changes.
 */
export function useMcapVirtualMcap(): McapVirtualMcapPageApi {
  const controller = useContext(McapVirtualMcapContext);
  if (!controller) throw new Error('useMcapVirtualMcap must be used under McapVirtualMcapProvider');
  return controller;
}
